// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

// routes
import { LocalizationProvider } from '@mui/x-date-pickers';
import { enUS as enUSAdapter } from 'date-fns/locale';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsDrawer, SettingsProvider } from 'src/components/settings';
// auth
import { AuthConsumer, AuthProvider } from 'src/auth/context';
import { Box } from '@mui/material';
import { SnackbarProvider } from './components/snackbar';
import { useAuthContext } from './auth/hooks';
import { HOST_API } from './config-global';


// ----------------------------------------------------------------------

function AppWithSettings() {

  return <SettingsProvider
    defaultSettings={{
      themeMode: 'light', // 'light' | 'dark'
      themeDirection: 'ltr', //  'rtl' | 'ltr'
      themeContrast: 'default', // 'default' | 'bold'
      themeLayout: "vertical", // 'vertical' | 'horizontal' | 'mini'
      themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
      themeStretch: true,
    }}
  >
    <ThemeProvider>
      <MotionLazy>
        <SnackbarProvider>
          <SettingsDrawer />
          <AuthConsumer>
            <Router />
          </AuthConsumer>
        </SnackbarProvider>
      </MotionLazy>
    </ThemeProvider>
  </SettingsProvider>
}

function LocalhostWarning() {
  return <Box sx={{position: "fixed", top: "0px", left:"50%", padding: "2px", paddingLeft: "6px", paddingRight: "6px", borderBottomLeftRadius:"4px", borderBottomRightRadius:"4px", transform: "translate(-50%)", zIndex:99999, background: "#F5523C", fontWeight: 700, textAlign: "center", color: "white"}}>
    You are connected to live!
  </Box>
}

export default function App() {
  useScrollToTop();

  return (
    <AuthProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {(HOST_API as any) === 'https://api.countingtrucks.com' && window.location.href.includes("localhost") && <LocalhostWarning />}
        <AppWithSettings />
      </LocalizationProvider>
    </AuthProvider>
  );
}
